import React, { Fragment } from 'react';
import {
  string,
  bool,
  shape,
} from 'prop-types';
import classNames from 'classnames';
import { isEnglishCharactersOrSpace, isChineseCharactersOrEmpty } from 'helpers/ValidationUtil';
import {
  Small,
} from 'components/common';
import Tooltip from 'components/common/Tooltip';
import CompareElementValue from './CompareElementValue';

import './CompareElementColumn.scss';

const getValueClassName = (verticalEnum, isText) => {
  let className = null;
  switch (verticalEnum) {
    case 'HI':
    case 'DH':
      className = 'ce-4-col-3';
      break;
    case 'TI':
      className = 'ce-4-col-2';
      break;
    case 'BA':
      className = 'ce-4-col-1';
      break;
    case 'SA':
    case 'HL':
      className = 'ce-3-col-2';
      break;
    case 'CC':
    case 'PL':
    default:
      className = 'ce-3-col-1';
      break;
  }

  return `${className}${isText ? '-text' : '-num'}`;
};

const CompareElementColumn = ({
  title,
  description,
  tooltip,
  isPremium,
  prefix,
  suffix,
  displayValue,
  originalPrice,
  tooltipId,
  subValue,
  originalPriceLabel,
  verticalEnum,
  hasLongPrefix,
}) => {
  const isText = isEnglishCharactersOrSpace(displayValue)
    || isChineseCharactersOrEmpty(displayValue);
  return (
    <div
      className={classNames({
        'compare-element-column': true,
        premium: isPremium,
      })}
      data-selector-type="compare-element-column"
    >
      <Tooltip
        primary
        id={tooltipId}
        text={tooltip}
      >
        {displayValue && (
          <Fragment>
            {hasLongPrefix && (
              <Small bold block className="long-prefix">
                {prefix}
              </Small>
            )}
            <div className={classNames('value', getValueClassName(verticalEnum, isText))}>
              <CompareElementValue
                value={displayValue}
                prefix={prefix}
                suffix={suffix}
                verticalEnum={verticalEnum}
              />
            </div>
          </Fragment>
        )}
        {title.display && (
          <Small primary bold block className="title">
            {title.display}
          </Small>
        )}
        {/* TODO: Check for 'BLANK_ENTRY' here is a temp fix for hiding Levy Paid for SS.
        See  RA-3072 for details */}
        {description && description !== 'BLANK_ENTRY' && (
          <Small secondary block className="description">
            {description}
          </Small>
        )}
        {originalPrice && (
          <Small secondary bold block className="original-value-description">
            {originalPriceLabel}
            &nbsp;
            <del>
              {prefix}
              {originalPrice}
            </del>
          </Small>
        )}
        {subValue && (
          <Small secondary block className="original-value-description">
            {subValue}
          </Small>
        )}
      </Tooltip>
    </div>
  );
};

CompareElementColumn.propTypes = {
  displayValue: string.isRequired,
  title: shape({}),
  description: string,
  tooltip: string,
  prefix: string,
  tooltipId: string,
  suffix: string,
  originalPrice: string,
  subValue: string,
  originalPriceLabel: string,
  isPremium: bool,
  verticalEnum: string,
  hasLongPrefix: bool,
};

CompareElementColumn.defaultProps = {
  title: {},
  description: null,
  tooltip: '',
  prefix: null,
  subValue: null,
  suffix: null,
  originalPrice: null,
  originalPriceLabel: null,
  isPremium: false,
  tooltipId: null,
  verticalEnum: null,
  hasLongPrefix: false,
};

export default CompareElementColumn;
